import { Form, Button, Card } from 'react-bootstrap'
import AppLoader from 'components/general/AppLoader';
import { toast } from 'react-toastify'
import { useSelector } from "react-redux"
import { useEffect, useState } from 'react'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export default function EditCard({ role, getRoles, showEditButton = false, onEdit, onCancel, onSave }) {

  const { user: authUser } = useSelector(x => x.auth)

  const url = process.env.REACT_APP_URL

  // console.log('event', event)

  const [name, setName] = useState('')
  const [description, setDescription] = useState(EditorState.createEmpty())
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    if (role) {
      setName(role.name)
      const contentBlock = htmlToDraft(role.description)
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
        const editorState = EditorState.createWithContent(contentState)
        setDescription(editorState)
      }
    }
  }, [role])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSaveLoading(true)

    const value = draftToHtml(convertToRaw(description.getCurrentContent()))
    try {
      const response = await fetch(`${url}/meetingrole/${role._id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        },
        body: JSON.stringify({
          name,
          description: value
        })
      })

      if (response.status === 200) {
        await response.json()
        getRoles() // Refresh the roles list
        if (onSave) onSave()
      } else {
        console.log(response)
        toast.error(`Failed to update role ${role.name}`, { position: 'bottom-left' })
      }
    } catch (error) {
      console.error(error)
      toast.error(`Failed to update role ${role.name}`, { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }
  return (
    <>
      {showEditButton ? (
        <Button
          variant="success"
          className='mb-1 float-end roles-admin-edit-btn'
          onClick={onEdit}
        >
          Edit Role
        </Button>
      ) : (
        <Card
          className='text-center roles-admin-form-card'
          data-bs-theme={'dark'}
        >

          <Card.Header className='roles-admin-form-header'>
            <Card.Title>
              Edit Role
            </Card.Title>
          </Card.Header>
          <Form>
            <Card.Body className='roles-admin-form-body'>
              <Form.Group className='mb-3'>
                <Form.Control
                  className='formInput'
                  placeholder='Role Name'
                  aria-label='Role Name'
                  name='role'
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group className='mb-3'>
                <Editor
                  editorState={description}
                  wrapperClassName="demo-wrapper"
                  toolbarClassName="toolbar-class"
                  editorClassName="editor-class"
                  onEditorStateChange={setDescription}
                  placeholder="Enter role description..."
                  toolbar={{
                    options: ['inline', 'blockType', 'list', 'textAlign', 'link'],
                    inline: {
                      options: ['bold', 'italic', 'underline']
                    },
                    blockType: {
                      inDropdown: false,
                      options: ['Normal', 'H4', 'H5', 'H6']
                    },
                    fontSize: {
                      visible: false,
                      options: [8, 9, 10, 11, 12, 14, 18]
                    },
                    list: {
                      inDropdown: false,
                      options: ['unordered', 'ordered']
                    },
                    textAlign: {
                      inDropdown: false
                    },
                    link: {
                      inDropdown: false
                    },
                    embedded: {
                      inDropdown: false
                    },
                  }}
                />
              </Form.Group>
            </Card.Body>
            <Card.Footer className='roles-admin-form-footer'>
              {saveLoading
                ?
                <>
                  <AppLoader />
                  Updating Role ...
                </>
                :
                <>
                  <Button variant="success" type='submit' onClick={handleSubmit} className='roles-admin-primary-btn'>
                    Update Role
                  </Button>
                  <Button variant="danger" onClick={onCancel} className='roles-admin-danger-btn'>
                    Cancel
                  </Button>
                </>
              }
            </Card.Footer>
          </Form>
        </Card>
      )}
    </>
  )
}
